var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Descrição do Material",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "descricao", $$v);
      },
      expression: "form.filters.descricao"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Formação",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.formacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "formacao", $$v);
      },
      expression: "form.filters.formacao"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Disciplina",
      "outlined": "",
      "dense": "",
      "items": _vm.disciplinas,
      "item-text": "nomeDisciplina",
      "item-value": "id"
    },
    model: {
      value: _vm.form.filters.disciplinaId,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "disciplinaId", $$v);
      },
      expression: "form.filters.disciplinaId"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Formato",
      "outlined": "",
      "dense": "",
      "items": _vm.$tiposAnexos,
      "item-text": "descricao",
      "item-value": "value"
    },
    model: {
      value: _vm.form.filters.formato,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "formato", $$v);
      },
      expression: "form.filters.formato"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Responsável",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.responsavel,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "responsavel", $$v);
      },
      expression: "form.filters.responsavel"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": function ($event) {
        return _vm.buscarMaterial();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.formatos`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(Array.isArray(item.formatos) ? item.formatos.join(', ') : '') + " ")];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": "Baixar Material",
            "icon": "mdi-download",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.baixarMaterial(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }